import { call, put, takeEvery } from 'redux-saga/effects';
import {activityReportActions} from './activityReportSlice';
import {getReportsByUser} from './activityReportBaseApi';
import { toastAction } from '../toast/toast';

function* loadReports({payload}) {
    try {
        const data = yield call(getReportsByUser, payload);
        yield put(activityReportActions.setReports(data || {}));
    } catch (error) {
        yield put(toastAction.onErrorToast(error?.message || error.error))
    }
}

export default function* activityReportSaga() {
    yield takeEvery(activityReportActions.loadReports, loadReports);
}